export default function videoWidget(widgetNameVariable, widgetOptsVariable) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: false,
    loopVideo: true, // autoPlayVideo must be enabled
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length < 1) {
        $('#videoSection').remove();
        $('.video-seoWidget-container').addClass('no-video');
      }
    },
  });
}
